import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useConfigStore } from '@/stores/configStore'
import { Settings, GlobalSettings } from '@/types/config'

export const useSettingsStore = defineStore('settings', () => {
  const configStore = useConfigStore()
  const { config } = storeToRefs(configStore)

  const settings = computed<Settings>(
    () => config.value?.rightCta?.settings || {}
  )

  const globalSettings = computed<Settings>(() => config.value?.settings || {})

  return {
    settings,
    globalSettings
  }
})
